import UserGuideManagement from "./user-guide-management.page";

export default UserGuideManagement;
